export default __webpack_public_path__ + "static/media/caen.922cf261.jpg";